/**
 * Opens {@link PageReloadDialog}.
 *
 * @param {any} _dummy1 - N/A for web.
 * @param {any} _dummy2 - N/A for web.
 * @param {any} _dummy3 - N/A for web.
 *
 * @returns {Function}
 */
export function openPageReloadDialog(_dummy1, _dummy2, _dummy3) {
    // Dummy
}
